module.exports = __webpack_public_path__ + "assets/cbfa45bfde461a7d33abe7818413b376.svg";